// extracted by mini-css-extract-plugin
export default {"header":"MultipleSubmitIndicator_header__ZqW+-","loading":"MultipleSubmitIndicator_loading__owLTR","placeHolderShimmer":"MultipleSubmitIndicator_placeHolderShimmer__QGnr6"};